import '../locales/i18n';

export default function I18nProvider({ children }) {
  return children;
}
